<template>
	<InfoText v-if="tnc_display" textClass="terms-and-conditions" :cacheKey="`tnc_${locale}`" :textUrl="`{m}backend/{env}/${locale}/tnc.html.gz`" @textHandler="textHandler" />
</template>

<script setup>
const { locale } = useI18n()

definePageMeta({
	layout: "info",
});

const tnc_display = ref(true)
const textHandler = (e) => {
	tnc_display.value = false;
}

</script>